import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { TreeviewItem } from 'ngx-treeview';
import { ListaMenuMSL, MenuService } from 'src/app/open-api';

@Component({
  selector: 'app-asignar-menu-modal',
  templateUrl: './asignar-menu-modal.component.html',
  styleUrls: ['./asignar-menu-modal.component.scss']
})
export class AsignarMenuModalComponent implements OnInit {

  @Input() menus?: string;
  config = {
    hasAllCheckBox: false,
    hasDivider: false,
    hasFilter: false,
    hasCollapseExpand: false,
    decoupleChildFromParent: false,
    maxHeight: 500
  };
  items: TreeviewItem[] = [];
  menuId: number[] = [];

  constructor(
    public activeModal: NgbActiveModal,
    private menuService: MenuService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
    this.ObtenerMenus();
  }

  ObtenerMenus(): void {
    this.spinner.show();
    this.menuService.apiV10MenuGet().subscribe(respuesta => {
      this.items = this.MenuParaTreeviewItems(respuesta.lista?.filter(m => m.menuPadreId === 0) || []);
      this.MarcarItems(this.items);
      this.spinner.hide();
    });
  }

  MenuParaTreeviewItems(menus: ListaMenuMSL[]): TreeviewItem[] {
    return menus.map(m => {
      return new TreeviewItem({
        text: m.nombre || '',
        value: m.id,
        children: this.MenuParaTreeviewItems(m.menuHijos || []),
      });
    });
  }

  MarcarItems(items: TreeviewItem[]): void {
    if (this.menus) {
      items.forEach(i => {
        if (this.menus?.split(',').map(x => +x).includes(i.value)) {
          i.checked = true;
        } else {
          i.checked = false;
        }
        i.correctChecked();
        if (i.children && i.children.length > 0) {
          this.MarcarItems(i.children);
        }
      });
    }
  }

  onSelectedChange(event: number[]): void {
    this.menuId = event;
  }

  Aceptar(): void {
    this.activeModal.close({ action: 'Aceptar', menu: this.menuId.toString() });
  }

  Cancelar(): void {
    this.activeModal.close({ action: 'Cancelar', menu: '' });
  }
}
